/* actiontypes */

export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";


export const GET_SINGLEPRODUCT_LOADING = "GET_SINGLEPRODUCT_LOADING";

export const GET_SINGLEPRODUCT_SUCCESS = "GET_SINGLEPRODUCT_SUCCESS";

export const GET_SINGLEPRODUCT_ERROR = "GET_SINGLEPRODUCT_ERROR";